export default "__VITE_ASSET__C4H70XyZ__"